/***************************************************************************
 * COPYRIGHT (C) 2015, Rapid7 LLC, Boston, MA, USA.
 * All rights reserved. This material contains unpublished, copyrighted
 * work including confidential and proprietary information of Rapid7.
 **************************************************************************/

/* jshint maxlen: false */
export default {
  insightvmNavMenus: {
    leftNav: {
      actions: 'Automated Actions',
      administration: 'Administration',
      assets: 'Assets',
      automation: 'Automation',
      aws: 'AWS Welcome',
      cloudGenerated: 'Cloud-Generated',
      consoleGenerated: 'Console-Generated',
      containers: 'Container Security',
      dashboard: 'Dashboard',
      goals: 'Goals and SLAs',
      home: 'Home',
      infrastructure: 'Cloud Configuration',
      management: 'Management',
      policies: 'Policies',
      policy: 'Policy',
      projects: 'Remediation Projects',
      reports: 'Reports',
      tickets: 'Tickets',
      vulnerabilities: 'Vulnerabilities',
    },
    topNav: {
      apiDocumenation: 'API Documentation',
      assetGroup: 'Asset Group',
      calendar: 'Calendar',
      contentUpdates: 'Content Updates',
      create: 'Create',
      dynamicAssetGroup: 'Dynamic Asset Group',
      enableSSO: 'Enable InsightVM Platform Login',
      explorer: 'Explorer',
      help: 'Help',
      logout: 'Logout',
      notifications: 'Notifications',
      productGuide: 'Product Guide',
      releaseNotes: 'Release Notes',
      report: 'Report',
      search: 'Search',
      site: 'Site',
      support: 'Support',
      tags: 'Tags',
      userPreferences: 'User Preferences',
    },
  },
};
